export const COMPARISON_OPERATORS = new Set([
  '==',
  '!=',
  '>=',
  '<=',
  '>',
  '<',
  'contains',
  'startsWith',
  'endsWith',
]);

export const GROUP_OPERATORS = new Set(['AND', 'OR']);

export const COLLECTION_PREDICATE_FUNCTIONS = new Set(['ANY', 'ALL', 'WHERE', 'SELECT']);

export const AGGREGATE_FUNCTIONS = new Set(['COUNT', 'SUM', 'MIN_BY', 'MAX_BY']);

export const OUTLINE_BADGE = {
  ALL: 'ALL',
  ANY: 'ANY',
  WHERE: 'WHERE',
  CALC: 'CALC',
  IF: 'IF',
  ERR: 'ERR',
};
